<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :title="title"
    :size="'lg'"
    :centered="true"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <!-- Sección de Reservas - OCULTA -->
    <!-- <div>
      <label>Reserva</label>
      <table class="table table-hover">
        <thead>
          <tr>
            <th width="60">N°</th>
            <th>Fecha</th>
            <th>A nombre de</th>
            <th>Monto</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data_reserva" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ formatDate(item.created_at) }}</td>
            <td>{{ item.sale.client.name }}</td>
            <td>{{ item.amount }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3" class="text-right font-weight-bold">Total:</td>
            <td class="font-weight-bold">{{ totalAmountReserva() }}</td>
          </tr>
        </tfoot>
      </table>
    </div> -->

    <!-- Sección de Ventas de Productos -->
    <div>
      <label>Ventas de Productos</label>
      <table class="table table-hover">
        <thead>
          <tr>
            <th width="60">N°</th>
            <th>Fecha</th>
            <th>A nombre de</th>
            <th>Monto</th>
            <th width="200">Cambiar a:</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ formatDate(item.created_at) }}</td>
            <td>{{ item.sale.client.name }}</td>
            <td>{{ item.amount }}</td>
            <td>
              <div class="btn-group-vertical" role="group">
                  <button 
                    v-for="method in availableMethods" 
                    :key="method.id"
                    @click="changePaymentMethodDirect(item, method)"
                    class="btn btn-sm mb-1"
                    style="background-color: white; color: #333; border: 1px solid #ddd;"
                    :title="`Cambiar a ${method.name}`"
                  >
                    <i class="fa fa-arrow-right"></i> {{ method.name }}
                  </button>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="3" class="text-right font-weight-bold">Total:</td>
            <td class="font-weight-bold">{{ totalAmount() }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Información adicional -->
    <div class="mt-3">
      <div class="alert alert-info">
        <i class="fa fa-info-circle"></i>
        <strong>Instrucciones:</strong> Haga clic en el botón del método de pago deseado para cambiar directamente cada venta.
      </div>
    </div>

    <template #footer>
      <button @click="mtdClose" class="btn btn-danger btn-sm">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </button>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../shared/modals/cModalFormCom.vue";

export default {
  name: "cModalGeneral",
  components: {
    CModal,
  },
  props: {
    title: String,
    boo_modal: Boolean,
    data: Array,           // Lista de ventas de productos
    data_reserva: Array,   // Lista de reservas - OCULTA
    currentMethodId: Number, // ID del método de pago actual
    allMethods: Array,     // Lista completa de métodos de pago
  },
  data() {
    return {
      hasShownGuidance: false,
    };
  },
  computed: {
    availableMethods() {
      if (!this.allMethods) return [];
      return this.allMethods.filter(method => method.id !== this.currentMethodId);
    }
  },
  watch:{
    boo_modal(newVal) {
      if (newVal && !this.hasShownGuidance) {
        this.showGuidance();
      }
    }
  },

  methods: {
    mtdClose() {
      this.$emit("closeModal");
    },
    // totalAmountReserva() {
    //   return this.data_reserva?.reduce((total, item) => {
    //     return total + parseFloat(item.amount);
    //   }, 0).toFixed(2);
    // },
    totalAmount() {
      return this.data?.reduce((total, item) => {
        return total + parseFloat(item.amount);
      }, 0).toFixed(2);
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('es-ES');
    },
    changePaymentMethodDirect(item, newMethod) {
      // Mostrar confirmación
      Swal.fire({
        title: '🔄 Cambiar Método de Pago',
        html: `
          <div style="text-align: left; padding: 15px;">
            <div style="margin-bottom: 15px; padding: 15px; background-color: #e3f2fd; border-radius: 8px;">
              <h5 style="margin: 0 0 10px 0; color: #1976d2;">
                <i class="fa fa-info-circle"></i> Detalles de la Venta
              </h5>
              <div style="background-color: #ffffff; padding: 10px; border-radius: 6px; border-left: 3px solid #1976d2;">
                <p style="margin: 5px 0;"><strong>Cliente:</strong> ${item.sale.client.name}</p>
                <p style="margin: 5px 0;"><strong>Fecha:</strong> ${this.formatDate(item.created_at)}</p>
                <p style="margin: 5px 0;"><strong>Monto:</strong> S/ ${parseFloat(item.amount).toFixed(2)}</p>
              </div>
            </div>
            
            <div style="margin-top: 20px; padding: 15px; background-color: #f8f9fa; border-radius: 8px;">
              <h5 style="margin-bottom: 10px; color: #333;">
                <i class="fa fa-exchange-alt"></i> Cambio de Método de Pago
              </h5>
              <div style="display: flex; align-items: center; justify-content: center; gap: 15px;">
                <div style="padding: 10px 15px; background-color: #dc3545; color: white; border-radius: 6px; font-weight: bold;">
                  Método Actual
                </div>
                <i class="fa fa-arrow-right" style="color: #007bff; font-size: 1.5em;"></i>
                <div style="padding: 10px 15px; background-color: #28a745; color: white; border-radius: 6px; font-weight: bold;">
                  ${newMethod.name}
                </div>
              </div>
            </div>
            
            <div style="margin-top: 15px; padding: 10px; background-color: #fff3cd; border-radius: 6px; text-align: center;">
              <small style="color: #856404;">
                ⚠️ Esta acción modificará el registro de la caja
              </small>
            </div>
          </div>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '<i class="fa fa-check"></i> Sí, Confirmar Cambio',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        customClass: {
          confirmButton: "btn btn-success btn-lg",
          cancelButton: "btn btn-secondary"
        },
        buttonsStyling: false,
        width: '650px',
      }).then((result) => {
        if (result.isConfirmed) {
          this.confirmChangePaymentMethodDirect(item, newMethod);
        }
      });
    },
    showGuidance() {
      Swal.fire({
        title: '💡 Instrucciones',
        html: `
          <div style="text-align: left; padding: 10px;">
            <p><strong>¿Cómo cambiar el método de pago?</strong></p>
            <ol style="margin-left: 20px;">
              <li>Localice la venta que desea cambiar</li>
              <li>Haga clic en el botón del método de pago destino</li>
              <li>Confirme la operación</li>
            </ol>
            <p style="margin-top: 10px; color: #6c757d;">
              <small>💡 Cada venta puede cambiarse individualmente a cualquier método de pago disponible</small>
            </p>
          </div>
        `,
        icon: 'info',
        confirmButtonText: 'Entendido',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        timer: 8000,
        timerProgressBar: true,
      });
      this.hasShownGuidance = true;
    },
    confirmChangePaymentMethodDirect(item, newMethod) {
      // Emitir evento al componente padre (el padre manejará el loading)
      this.$emit('onChangePaymentMethod', {
        oldMethodId: this.currentMethodId,
        newMethodId: newMethod.id,
        totalAmount: parseFloat(item.amount),
        selectedChargeIds: [item.id]
      });
    }
  },
};
</script>

<style scoped>
</style>
